import toastr from 'toastr';

import Service from "../../../utility/Service";

export const CANCELLED_ORDERS_GET_SUCCESS = "CANCELLED_ORDERS_GET_SUCCESS";
export const CANCELLED_ORDERS_GET_FAILURE = "CANCELLED_ORDERS_GET_SUCCESS";
export const CANCELLED_ORDERS_GET_REQUEST = "CANCELLED_ORDERS_GET_SUCCESS";

/**
 * All plans Request
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export const cancelledordersGetRequest = () => ({
    type: CANCELLED_ORDERS_GET_REQUEST,
    loading: true,
    cancelledOrderData: []
});
/**
 * All plans Success
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export const cancelledordersGetSuccess = (data, pageNo, pageSize) => ({
    type: CANCELLED_ORDERS_GET_SUCCESS,
    loading: false,
    cancelledOrderData: data
});
/**
* All plans Failure
* @param  {[type]} data [description]
* @return {[type]}      [description]
*/
export const cancelledordersGetFailure = () => ({
    type: CANCELLED_ORDERS_GET_FAILURE,
    loading: false,
    cancelledOrderData: []
});

/**
 * Login
 * @param  {[type]} fields [description]
 * @return {[type]}        [description]
 */

export const getcancelledorders = (value, pageNo, pageSize) => (dispatch, getState) => {
    toastr.remove()
    dispatch(cancelledordersGetRequest())
    // let url = "order?offset=0&status=cancelled&populate=all&limit=500"
    let url = "order/all/filter"
    // if (pageNo && pageSize) {
    // url = "order?offset=0&status=open&populate=all?page=" + pageNo + "&page_size=" + pageSize
    // }
    Service.post(url, value,
        (response) => {
            if (response && response.status && response.status === 200) {
                // toastr.success(response.message ? response.message : 'Locale.actions.usersReceivedSuccessfully');
                // console.log(response);
                let data = {
                    orders: response.data,
                    pagination: response.pagination
                }
                dispatch(cancelledordersGetSuccess(data));
            } else {
                console.log("cancelledorder error", response);
                dispatch(cancelledordersGetFailure());
                // toastr.error(response && response.message && response.message.non_field_errors ? response.message.non_field_errors.join() : response.message ? response.message : 'Something Went Wrong');
                toastr.error('Something Went Wrong');
            }
        }
    )
};

